import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { promoCodeConfigFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteFAQFragment = contentfulGql`#graphql
  ${promoCodeConfigFragment}
  fragment EntWebsiteFAQ on EntWebsiteFaq {
    slug
    title
    promoCodeConfigsCollection {
      items {
        ...PromoCodeConfig
      }
    }
    questionsCollection(limit: 20) {
      items {
        __typename
        sys {
          id
        }
        question
        answer
        promoCodeConfigsCollection {
          items {
            ...PromoCodeConfig
          }
        }
      }
    }
  }
`;

export const entWebsiteBlockFAQQuery = contentfulGql`#graphql
${entWebsiteBlockAssemblyFragment}
${entWebsiteFAQFragment}

   query entWebsiteBlockFAQ($id: String!, $preview: Boolean, $locale: String!) {
     entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
       ...EntWebsiteBlockAssembly
       reference {
         __typename
        ...EntWebsiteFAQ
       }
     }
   }
`;
